// extracted by mini-css-extract-plugin
export default {"scrollContainer":"etG_wNIo_WvZClFyDIOW","formContainer":"ceyDATjU32lxY9kNegp5","footerBtn":"ROgcorZ1ZLi_9knefFcR","actionBtn":"znmW2fqImCZ1wjwXCSWr","bounce":"eqiySMBqxsj6szlEd6Xz"};